<div class="flex flex-col gap-4 w-fill-available">
  <div class="flex items-center gap-4 w-fill-available justify-between h-7">
    <div class="flex items-center gap-2 h-7">
      <app-profile-date-filter
        [campaignAnalytics]="null"
        [hideAllTimeRangeOption]="true"
        [initialState]="dateFilterState()"
        [loading]="loading()"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (selectedRangeChanged)="onSelectedRangeChanged($event)"
      />
    </div>
  </div>
</div>
